import { c as _c } from "react/compiler-runtime";
import MachineProvider from './components/machine-provider';
import Router from './pages/router';
import type { LivenessProps } from './types';
const AppWithMachine = t0 => {
  const $ = _c(8);
  const {
    actionKind,
    idvContext,
    onDone
  } = t0;
  let t1;
  if ($[0] !== idvContext) {
    t1 = {
      idvContext
    };
    $[0] = idvContext;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== actionKind || $[3] !== onDone) {
    t2 = <Router actionKind={actionKind} onDone={onDone} />;
    $[2] = actionKind;
    $[3] = onDone;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <MachineProvider initialContext={t1}>{t2}</MachineProvider>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default AppWithMachine;